import { IClassname } from '@/lib/shared/model/classname';

export const CoDetector = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.41557 1.3042C6.24713 1.30747 6.0865 1.37584 5.96738 1.49497C5.84825 1.61409 5.77988 1.77472 5.77661 1.94316V3.22107C5.78103 3.65808 5.86325 4.09081 6.01942 4.49899L8.08964 9.61066C8.17217 9.77735 8.29708 9.91942 8.45185 10.0226C8.60661 10.1258 8.78579 10.1864 8.9714 10.1985H23.0285C23.2141 10.1864 23.3933 10.1258 23.548 10.0226C23.7028 9.91942 23.8277 9.77735 23.9102 9.61066L25.9805 4.49899C26.1366 4.09081 26.2189 3.65808 26.2233 3.22107V1.94316C26.22 1.77472 26.1516 1.61409 26.0325 1.49497C25.9134 1.37584 25.7528 1.30747 25.5843 1.3042H6.41557Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.79883 6.41602H25.2008"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 6.41602V10.2498"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4727 6.41602L19.8337 10.2498"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5273 6.41602L12.1663 10.2498"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3895 10.2495C22.3895 12.013 19.8337 14.0833 15.9999 14.0833C12.1662 14.0833 9.61035 12.013 9.61035 10.2495"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6756 26.6675C22.6756 27.3453 22.4064 27.9954 21.927 28.4747C21.4477 28.9541 20.7976 29.2233 20.1198 29.2233C19.4419 29.2233 18.7919 28.9541 18.3126 28.4747C17.8332 27.9954 17.564 27.3453 17.564 26.6675V21.5558C17.564 20.878 17.8332 20.2279 18.3126 19.7486C18.7919 19.2693 19.4419 19 20.1198 19C20.7976 19 21.4477 19.2693 21.927 19.7486C22.4064 20.2279 22.6756 20.878 22.6756 21.5558V26.6675Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1117 29.2233C14.4404 29.2233 13.7757 29.0911 13.1555 28.8342C12.5353 28.5773 11.9718 28.2008 11.4972 27.7262C11.0225 27.2515 10.646 26.688 10.3891 26.0678C10.1322 25.4476 10 24.7829 10 24.1117C10 23.4404 10.1322 22.7757 10.3891 22.1555C10.646 21.5353 11.0225 20.9718 11.4972 20.4972C11.9718 20.0225 12.5353 19.646 13.1555 19.3891C13.7757 19.1322 14.4404 19 15.1117 19"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
